import { render, staticRenderFns } from "./CharacterManagement.vue?vue&type=template&id=3cb70416&scoped=true"
import script from "./CharacterManagement.vue?vue&type=script&lang=js"
export * from "./CharacterManagement.vue?vue&type=script&lang=js"
import style0 from "./CharacterManagement.vue?vue&type=style&index=0&id=3cb70416&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb70416",
  null
  
)

export default component.exports